function withSlug(name) {
  return { name, slug: name.toLowerCase().replace(/\./g, "-") };
}

module.exports.withSlug = withSlug;
